import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ProductPage } from './pages/ProductPage';
import { useScreenInit } from './useScreenInit';
import { OrderModal } from './components/OrderModal';
import { AddedToCartModal } from './components/AddedToCartModal';
import { Header } from './components/Header';
function AppRoutes() {
  useScreenInit();
  return <>
      <Header data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/product/:id" element={<ProductPage data-id="element-5" />} data-id="element-4" />
      </Routes>
      <OrderModal data-id="element-6" />
      <AddedToCartModal data-id="element-7" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-8">
      <AppRoutes data-id="element-9" />
    </BrowserRouter>;
}